<template>
  <div :class="$style.sectionRoot">
    <div :class="$style.header">
      <h2 :class="$style.sectionHeader">
        {{ title }}
        <span
          v-if="shouldShowCount"
          :class="getCountClassName"
        >
          {{ `(${totalCount})` }}
        </span>
        <slot name="icon" />
      </h2>
      <a
        v-if="shouldShowAllLink"
        :class="$style.resourcesAllLink"
        rel="noopener noreferrer"
        @click="$emit('navigateToFullList')"
      >
        {{ linkTitle }}
      </a>
    </div>
    <div :class="$style.sectionContent">
      <div
        v-if="isLoading"
        :class="$style.loadingIconContainer"
      >
        <LoadingIcon />
      </div>
      <div
        v-if="hasError"
        :class="$style.message"
      >
        There was an error retrieving this data.
      </div>
      <div
        v-if="!disableZeroState && !isLoading && !hasError && totalCount === 0"
        :class="$style.message"
      >
        <slot name="zeroState" />
      </div>
      <div
        v-if="disableZeroState || (!isLoading && !hasError && totalCount > 0)"
        :class="$style.message"
      >
        <slot name="mainContent" />
      </div>
    </div>
  </div>
</template>

<script>
import LoadingIcon from 'components/LoadingOverlay/LoadingIcon.vue';

export default {
  name: 'HighlightsWidget',

  components: {
    LoadingIcon,
  },

  props: {
    disableZeroState: Boolean,

    fullLinkTitle: {
      type: String,
      default: '',
    },

    hasError: Boolean,

    icon: {
      type: Object,
      default: undefined,
    },

    isLoading: Boolean,

    showLinkToFullList: Boolean,

    title: {
      type: String,
      default: 'Resources',
    },

    totalCount: {
      type: Number,
      default: undefined,
    },
  },

  computed: {
    getCountClassName() {
      return `${this.title.replace(/\s+/g, '')}__Count`;
    },

    linkTitle() {
      return this.fullLinkTitle ? this.fullLinkTitle : `all ${this.title.toLowerCase()}`;
    },

    shouldShowAllLink() {
      return this.showLinkToFullList && (this.totalCount > 0 || this.disableZeroState);
    },

    shouldShowCount() {
      return this.totalCount && (!this.isLoading && typeof this.totalCount === 'number');
    },
  },
};
</script>

<style module>
@import '../../css/sections.css';
@import './css/highlights.css';

@value (jcGrey600, jcInformationalBase) from '~css/brand-colors.css';

.sectionRoot {
  --highlightsMargin: 1rem;
  --defaultHighightsFontSize: 16px;
  --defaultHighightsFontWeight: 600;

  margin-bottom: var(--highlightsMargin);
  min-width: auto;
}

@media screen and (max-width: 1368px) {
  .sectionRoot { padding: 20px; }
}

.sectionContent { padding-bottom: 10px; }

.header {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}

.loadingIconContainer {
  margin-top: 10px;
  text-align: center;
}

.message {
  text-align: center;
}

</style>
